import { IMenuDetailsFieldsLabels } from './MenuDetailsFields';

/** Labels for the menu set details fields, shared by Create Menu Set and the edit details tray. */
export const MENU_SET_DETAILS_LABELS: IMenuDetailsFieldsLabels = {
  name: 'Menu Set Name (internal)',
  nameRequired: 'Please enter a menu set name',
  consumerName: 'Consumer Menu Set Name*',
  consumerNameNote:
    '*This is the name used for the published menu. If no consumer name is provided, the internal menu name will be published',
  image: 'Menu Set image:',
  sourceTitle: 'Menu Source:',
  menuSetSource: { library: 'All Menus', menuLabels: 'Use defined menu labels', ranges: 'Use defined Ranges' },
};

export const UNIQUE_MENU_SET_NAME_ERROR = 'Menu set name must be unique';
